import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CapitalizePipe } from '../../pipes';
import { ClientInvoiceBadgeColor, ClientInvoiceStatus } from '../../enums';
import { EnumValues, StatusBadgePipe } from './DocumentStatus.pipe';

type StatusBadgeField = 'label' | 'badge';

@Pipe({
  name: 'clientInvoiceStatusBadge',
  standalone: true,
})
export class ClientInvoiceStatusBadgePipe implements PipeTransform {
  #translate = inject(TranslateService);
  #capitalize = inject(CapitalizePipe);

  pipe = new StatusBadgePipe(ClientInvoiceStatus, ClientInvoiceBadgeColor);

  transform(
    status?: EnumValues<typeof ClientInvoiceStatus>,
    field: StatusBadgeField = 'label',
  ): string | EnumValues<typeof ClientInvoiceBadgeColor> {
    const val = this.pipe.transform(status);

    if (!val) {
      return field === 'label' ? 'UNKNOWN' : 'new';
    }

    return field === 'label' ? this.#capitalize.transform(this.#translate.instant(val.label)) : val.badge;
  }
}
